'use strict';

// Declare app level module which depends on views, and components
var myApp = angular.module('routes', ['myApp']);
myApp.config(['$stateProvider', '$locationProvider', '$urlRouterProvider', '$httpProvider', '$ocLazyLoadProvider', 'RouteHelpersProvider', '$localStorageProvider', 'Api', 'briefcaseConstants', function ($stateProvider, $locationProvider, $urlRouterProvider, $httpProvider, $ocLazyLoadProvider, helper, $localStorageProvider, Api, briefcaseConstants) {
    //$locationProvider.hashPrefix('!');

    $httpProvider.interceptors.push('tokenInjector');
    $ocLazyLoadProvider.config({
        debug: false,
        events: true,
    });
    $localStorageProvider.setKeyPrefix('PraosHealth');
    briefcaseConstants.BASE_URL = Api.url;
    briefcaseConstants.BASE_URL2 = Api.url2;
    briefcaseConstants.DOCUMENT_TAB_IFRAME_URL = Api.document_tab_iframe_url;
    briefcaseConstants.ADMIN_DOCUMENT_TAB_IFRAME_URL = Api.admin_document_tab_iframe_url;
    briefcaseConstants.TASK_TAB_IFRAME_URL = Api.task_tab_iframe_url;
    briefcaseConstants.ADMIN_TASK_TAB_IFRAME_URL = Api.admin_task_tab_iframe_url;
    /*
     Set the following to true to enable the HTML5 Mode
     You may have to set <base> tag in index and a routing configuration in your server
     */
    $locationProvider.html5Mode(false);

    $urlRouterProvider.otherwise('/splash');
    $stateProvider
        .state('login', {
            templateUrl: 'views/pages/login.html',
            url: '/login?:r',
            controller: 'LoginCtrl',
        })
        .state('signup', {
            templateUrl: 'views/pages/signup.html',
            url: '/signup',
            controller: 'SignupCtrl',
        })
        .state('verify', {
            templateUrl: 'views/pages/emailVerify.html',
            url: '/verify/:user_id',
            controller: 'EmailVerifyCtrl',
        })
        .state('activate', {
            templateUrl: 'views/pages/prn-activate.html',
            url: '/activate/:user_id/:token?organization_id&recruiter_id&isMarketplace',
            controller: 'PrnActivateCtrl',
            controllerAs: 'viewModel',
        })
        .state('contact', {
            templateUrl: 'views/pages/contact.html',
            url: '/contact?name&userId&orgId&coBrandedUrl',
            controller: 'ContactCtrl',
            controllerAs: 'viewModel',
        })
        .state('contactme', {
            templateUrl: 'views/pages/contactme.html',
            url: '/contactme',
            params: {
                'userName': null, 
                'userId': null, 
                'coBrandedUrl': null
            },
            controller: 'ContactMeCtrl',
            controllerAs: 'viewModel',
        })
        //Co-Branded Signup route
        .state('coBrandedSignup',{
            templateUrl:'views/pages/coBranded-signup.html',
            url:'/co-branded-signup/:coBrandedKEY',
            controller:'PrnSignupCtrl',
            controllerAs: 'viewModel',
        })
        /*Co-Branded login route*/
        .state('coBrandedLogin', {
            templateUrl: 'views/pages/login.html',
            url: '/co-branded-login/:coBrandedKEY?:r',
            controller: 'LoginCtrl',
        })
        .state('regenerateLink', {
            templateUrl: 'views/pages/regenerate-link.html',
            url: '/regenerate-link/:emailVerificationToken',
            controller: 'RegenerateLinkCtrl',
            controllerAs: 'viewModel',
        })
        .state('resetPassword', {
            templateUrl: 'views/pages/resetPassword.html',
            url: '/reset-password/:email/:token',
            controller: 'ResetPasswordCtrl'
        })
        .state('logout', {
            url: '/logout',
            controller: 'LoginCtrl'
        })
        .state('dashboard', {
            url: '/dashboard',
            abstract: true,
            controller: 'MainCtrl as main',
            templateUrl: 'dashboard/main.html'
        })
        .state('dashboard.profile', {
            url: '/profile?folderId&event',
            controller: 'ProfileCtrl',
            templateUrl: 'views/profile.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.license', {
            url: '/license',
            controller: 'ProfileCtrl',
            templateUrl: 'views/profile.html',
            data: { requiresLogin: true, briefcaseMinStep: 1 },
        })
        .state('dashboard.education', {
            url: '/education',
            controller: 'ProfileCtrl',
            templateUrl: 'views/profile.html',
            data: { requiresLogin: true, briefcaseMinStep: 2  },
        })
        .state('dashboard.documents', {
            url: '/documents',
            controller: 'ProfileCtrl',
            templateUrl: 'views/profile.html',
            data: { requiresLogin: true, briefcaseMinStep: 2  },
        })
        .state('dashboard.tasks', {
            url: '/tasks',
            controller: 'ProfileCtrl',
            templateUrl: 'views/profile.html',
            data: { requiresLogin: true, briefcaseMinStep: 3  },
        })
        .state('education', {
            url: '/education?folderId&event',
            controller: 'educationResource',
            controllerAs: 'viewModel',
            templateUrl: 'views/education-resource.html',
            data: { requiresLogin: true },
        })
        .state('splash', {
            url: '/splash',
            controller: 'ProfileNewCtrl',
            controllerAs: 'viewModel',
            templateUrl: 'views/profile-new.html',
            data: { requiresLogin: true },
        })
        .state('success', {
            url: '/success',
            controller: 'AppSuccessCtrl',
            controllerAs: 'viewModel',
            templateUrl: 'views/application-success.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.jobs', {
            url: '/jobs?search',
            controller: 'JobsCtrl',
            templateUrl: 'views/jobs.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.contactUs', {
            url: '/contactUs',
            controller: 'ContactUsCtrl',
            templateUrl: 'views/contactUs.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.help', {
            url: '/help',
            controller: 'HelpCtrl',
            templateUrl: 'views/help.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.notification', {
            url: '/notification',
            controller: 'notificationCtrl',
            templateUrl: 'views/notification.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.myIncome', {
            url: '/income',
            controller: 'MyIncomeCtrl',
            controllerAs: 'MyIncomeVM',
            templateUrl: 'views/myIncome.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.calendar', {
            url: '/calendar',
            controller: 'CalendarCtrl',
            templateUrl: 'views/calendar.html',
            data: { requiresLogin: true },
        })
        .state('dashboard.setting', {
            url: '/setting',
            controller: 'SettingCtrl',
            controllerAs: 'SettingVM',
            templateUrl: 'views/setting.html',
            data: { requiresLogin: true },
        })
        .state('page404', {
            url: '/page404',
            controller: 'Page404Ctrl',
            controllerAs: 'Page404vm',
            templateUrl: 'views/pages/page404.html',
            data: { requiresLogin: true },
        })
        .state('nurseDashboard',{
            url:'/nurseDashboard/:token/:userId?:r',
            templateUrl: 'views/pages/nurse-redirect.html',
            controller:'NurseRedirectController',
            params: {
                userId: { squash: true, value: null }
            },
            data: { main: true }
        })
}]);
myApp.config(['$uibTooltipProvider', function ($uibTooltipProvider) {
    $uibTooltipProvider.setTriggers({
        'mouseenter': 'mouseleave',
        'click': 'click',
        'focus': 'blur',
        'never': 'mouseleave' // <- This ensures the tooltip will go away on mouseleave
    });
}]);
myApp.config(['$provide', function ($provide) {

    $provide.decorator('ngModelDirective', function ($delegate) {
        var ngModel = $delegate[0], controller = ngModel.controller;
        ngModel.controller = ['$scope', '$element', '$attrs', '$injector', function (scope, element, attrs, $injector) {
            var $interpolate = $injector.get('$interpolate');
            attrs.$set('name', $interpolate(attrs.name || '')(scope));
            $injector.invoke(controller, this, {
                '$scope': scope,
                '$element': element,
                '$attrs': attrs
            });
        }];
        return $delegate;
    });

    $provide.decorator('formDirective', function ($delegate) {
        var form = $delegate[0], controller = form.controller;
        form.controller = ['$scope', '$element', '$attrs', '$injector', function (scope, element, attrs, $injector) {
            var $interpolate = $injector.get('$interpolate');
            attrs.$set('name', $interpolate(attrs.name || attrs.ngForm || '')(scope));
            $injector.invoke(controller, this, {
                '$scope': scope,
                '$element': element,
                '$attrs': attrs
            });
        }];
        return $delegate;
    });
}]);
myApp.run(['$rootScope', function ($rootScope) { $rootScope._ = _; }]);
myApp.filter('capitalize', function () {
    return function (input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    }
});
myApp.config(function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://www.esigngenie.com/**'
    ]);
});
myApp.filter('removeString', function () {
    return function (text) {
        if (text) {
            var str = '//' + text.replace(/https:\/\/|http:\/\//ig, '');
            return str;
        }

    };
});
myApp.filter('imgSrc', function() {
    return function(input) {
        if (!input || typeof input !== 'string') return 'img/profile.jpg';
        const url = new URL(input);
        url.searchParams.append('v', Date.now());
        return url.toString();
    }
});
myApp.config(['KeepaliveProvider' , function(KeepaliveProvider) {
    KeepaliveProvider.interval(10); // in seconds
    console.log("IdleProvider and KeepaliveProvider configured");
}]);
